"use client";
import { useGlobalContext } from "../../../../app/context/store";
import { DisplayLoadingState, DisplayMedia, useGenerator } from "@/app/context/GeneratorContext";
import { createPost, createGif } from "../../../../lib/api/post";
import { useUpgradeModal } from "../../toggles/upgrade-modal";
import { useCallback, useState } from "react";
import BanModal from "@/components/ban/banModal";

export default function SecondaryMenu({
  translations,
  banTranslations,
}: {
  translations: any;
  banTranslations: any;
}) {
  const { user } = useGlobalContext();
  const { state, displayLoadingState, displayMedia, displayMediaIndex, setDisplayMedia } =
    useGenerator();
  const { UpgradeModal } = useUpgradeModal(translations);
  const [savingStates, setSavingStates] = useState<boolean[]>(
    new Array(displayMedia?.length || 0).fill(false),
  );
  const [showBanModal, setShowBanModal] = useState(false);

  const saveMedia = useCallback(
    async (media: DisplayMedia, index: number) => {
      const url = media.imageUrl || media.videoUrl;
      if (!url) {
        console.error("Media URL is undefined");
        return;
      }

      if (user._id === "none") {
        window.alert(translations.accessViaAccount);
        return;
      }

      const newSavingStates = [...savingStates];
      newSavingStates[index] = true;
      setSavingStates(newSavingStates);

      const fileName = url.split("/").pop() || "";
      const { postResponse, error } =
        media.type === "image" ? await createPost(fileName) : await createGif(fileName);
      if (postResponse) {
        const newMedia = displayMedia.map((item, i) =>
          i === index ? { ...item, saved: true } : item,
        );
        setDisplayMedia(newMedia);
      }

      newSavingStates[index] = false;
      setSavingStates(newSavingStates);
    },
    [displayMedia, savingStates],
  );

  const preSaveCheck = () => {
    if (user.banned?.level === 1) {
      setShowBanModal(true);
      return false;
    }
    return true;
  };

  const renderSaveButton = () => {
    if (Array.isArray(displayMedia) && displayMedia.length > 0) {
      return (
        <button
          disabled={
            state.detectCelebrity ||
            displayMedia[displayMediaIndex]?.saved ||
            savingStates[displayMediaIndex]
          }
          onClick={() => {
            if (preSaveCheck()) {
              saveMedia(displayMedia[displayMediaIndex], displayMediaIndex);
            }
          }}
          className={`flex w-24 min-w-min flex-row items-center justify-center px-4 py-4 text-sm font-medium focus:outline-none focus:ring-0 ${
            displayMedia[displayMediaIndex]?.saved
              ? "text-[#23e000]"
              : state.detectCelebrity
              ? "text-[#404245]"
              : "cursor-pointer text-[#23e000]"
          }`}
        >
          <div className="mr-1">{displayMedia[displayMediaIndex]?.saved ? "♥" : "♡"}</div>
          <div className="whitespace-nowrap font-bold">
            {displayMedia[displayMediaIndex]?.saved
              ? translations.saved
              : savingStates[displayMediaIndex]
              ? translations.saving
              : translations.save}
          </div>
        </button>
      );
    }

    return null;
  };

  return (
    <>
      <UpgradeModal />
      <BanModal
        isOpen={showBanModal}
        onClose={() => setShowBanModal(false)}
        translations={banTranslations}
      />
      <div
        className={`${
          displayLoadingState == DisplayLoadingState.Loaded ? "block" : "hidden"
        } -mt-5 mb-6 flex flex-row items-center justify-center border-b-[0.5px] border-l-[0.5px] border-r-[0.5px] border-[#3C3C3C] bg-[#2B2D31] shadow-lg sm:rounded-bl-xl sm:rounded-br-xl`}
      >
        {renderSaveButton()}
      </div>
    </>
  );
}
